import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default function ContactSidebar() {
  return (
    <div className="w-full hidden md:flex flex-col md:w-1/3 md:pl-12 md:mt-36">
      <p>
        <span className="font-semibold">Brussels-Africa Hub AISBL</span><br/>
        <i>International Non-Profit Organisation</i><br/><br/>
        Avenue du Houx 18, Bus 2<br/>
        1170 Watermael-Boitsfort, Belgium<br/>
        BE 0682.586.426<br/>
        <a href="mailto:info@brusselsafricahub.eu">info@brusselsafricahub.eu</a>
      </p>
      <div className="flex flex-row mt-4">
        <a href="https://www.linkedin.com/company/brussels-africa-hub/" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faLinkedin} className="text-lg"/>
        </a>
      </div>
    </div>
  );
}
